<span class="confidence sp-py-2 sp-px-6 bg-color-success-8 fs-11px fw-700 text-color-gray-1">MEDIUM</span>
